import { Schema } from "mongoose"
import { z } from "zod"


export const ZRBUploadChunk = z.object({
  uploadId: z.string(),
  index: z.number().int().min(0),
  data: z.unknown(),
  size: z.number().int().min(0),
  sha256: z.string().optional(),
  createdAt: z.date(),
  expiresAt: z.date(),
})

export type IRBUploadChunk = z.infer<typeof ZRBUploadChunk>

export const RBUploadChunkSchema: Schema = new Schema(
  {
    uploadId: { type: String, required: true, index: true },
    index: { type: Number, required: true },
    data: { type: Buffer, required: true },
    size: { type: Number, required: true },
    sha256: { type: String, required: false },
    createdAt: { type: Date, required: true, default: Date.now },
    expiresAt: { type: Date, required: true },
  },
  {
    versionKey: false,
  },
)

RBUploadChunkSchema.index({ uploadId: 1, index: 1 }, { unique: true })
RBUploadChunkSchema.index({ expiresAt: 1 }, { expireAfterSeconds: 0 })
